<div class="action-buttons"
     [class.action-buttons--visible]="visible"
     aria-label="Ações da nota fiscal">
  <p-button
    *ngFor="let action of actions; trackBy: trackAction"
    [pTooltip]="action.label"
    tooltipPosition="top"
    [loading]="isLoading(action)"
    [disabled]="isDisabled(action)"
    [rounded]="true"
    [text]="true"
    severity="secondary"
    (click)="onSelect(action)">
    <ng-template pTemplate="icon">
      <split-icon [name]="action.icon" size="18"></split-icon>
    </ng-template>
  </p-button>
</div>
